<template lang="html">
  <div>
    <div class="form" style="background-color: rgba(0,0,0,0); box-shadow:none;" v-show="!!project.usedStorage">
      <div class="cell" style="padding-left: 0">
        <span>{{message.Sl235}}: </span>
        <span>{{project.usedStorage}} / {{project.storageQuota}}</span>
      </div>
    </div>
    <div class="form">
      <div class="pkg" v-loading="loading">
        <div class="title">{{message.Sl147}}</div>
        <div class="cover" v-show="!active1">
          <span class="edit" @click="editPkg">{{message.Sl127}}</span>
        </div>
        <div class="pkg-cell"  style="padding-top:10px;width: 500px;text-align:left">
          <!-- <el-checkbox class="ck1" v-model="form.ck1" style="margin-left:15px">
            自动删除   {{ view.after }}
            <el-select v-model="form.after" style="width: 78px" v-show="active1">
              <el-option v-for="item in options4"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-checkbox> -->
          <div class="cell">
            <el-checkbox class="ck1" v-model="form.ck1">
              {{message.Sl148}}
              <span class="overflow" v-show="!active1">
                {{ view.after }}
              </span>
            </el-checkbox>
            <el-select v-model="form.after" size="small" style="width:100px;margin-left:5px" v-show="active1">
              <el-option v-for="item in options4"
                :key="item.label"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div class="cell">
            <el-checkbox class="ck2" v-model="form.ck2">
              {{message.Nl114}}
              <span class="overflow" v-show="!active1">
                {{ view.downloadAfter }}
              </span>
            </el-checkbox>
            <el-select v-model="form.downloadAfter" size="small" style="width:100px;margin-left:5px" v-show="active1">
              <el-option v-for="item in options5"
                :key="item.label"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div class="cell">
              <span>
                {{ message.Sl234 }}
              </span>
              <span class="overflow" v-show="!active1">
                {{ form.saveMode }}
              </span>
            <el-select v-model="form.saveMode" size="small" style="width:100px;margin-left:5px" v-show="active1">
              <el-option v-for="item in saveModes"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <!-- <el-checkbox v-model="form.ck3">
            允许发件人设置过期时间
          </el-checkbox> -->
          <!-- <el-form-item label="边上传边下载：">
            <el-switch on-text="" off-text="" v-model="form2."></el-switch>
          </el-form-item> -->
          <div style="padding-top:25px;text-align:center;" v-show="active1">
            <el-button type="primary" style="width:80px" size='small' @click="onSubmitA">{{message.Fl126}}</el-button>
            <el-button style="width:80px" size='small' @click="resetA">{{message.Fl101}}</el-button>
          </div>
        </div>
      </div>
      <!-- <div class="transfer" v-loading="loading2">
        <div class="cover" v-show="!active2">
          <span class="edit" @click="editTransfer">编辑</span>
        </div>
        <div class="title">传输设置</div>
        <el-form ref="transferForm" :rules="rules" :model="form2" label-width="180px" style="width: 500px;text-align:left">
          <el-form-item label="限制上传带宽：">
            <el-switch on-text="" off-text="" v-model="form2.bpsUploadFalse"></el-switch>
          </el-form-item>
          <el-form-item label="总上传带宽：" v-show="form2.bpsUploadFalse">
            {{ view2.upload }}
            <el-col :span='9'>
              <el-form-item prop="upload">
                <el-input v-model.number="form2.uploadValue" style="width:110px" v-show="active2"></el-input>
              </el-form-item>
            </el-col>
            <el-select v-model="form2.uploadUnit" style="width: 85px" v-show="active2">
              <el-option v-for="item in options"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="限制下载带宽：">
            <el-switch on-text="" off-text="" v-model="form2.bpsDownloadFalse"></el-switch>
          </el-form-item>
          <el-form-item label="总下载带宽：" v-show="form2.bpsDownloadFalse">
            {{ view2.download }}
            <el-col :span='9'>
              <el-form-item prop="download">
                <el-input v-model.number="form2.downloadValue" style="width:110px" v-show="active2"></el-input>
              </el-form-item>
            </el-col>
            <el-select v-model="form2.downloadUnit" style="width: 85px" v-show="active2">
              <el-option v-for="item in options"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="文件存储模式：">
            {{ view2.mode }}
            <el-select v-model="form2.mode" style="width: 110px;left:0" v-show="active2">
              <el-option v-for="item in options2"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="最多切片数：" v-show="form2.mode===0">
            {{ view2.segNum }}
            <el-col :span='9'>
              <el-form-item prop="num">
                <el-input v-model.number="form2.segNum" style="width:110px" v-show="active2"></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="最小切片尺寸(50MB)：" v-show="form2.mode===0">
            {{ view2.segSize }}
            <el-col :span='9'>
              <el-form-item prop="size">
                <el-input v-model.number="form2.segValue" style="width:110px" v-show="active2"></el-input>
              </el-form-item>
            </el-col>
            <el-select v-model="form2.segUnit" style="width: 85px" v-show="active2">
              <el-option v-for="item in options3"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="padding-top:20px" v-show="active2">
            <el-button type="primary" @click="onSubmitB">立即修改</el-button>
            <el-button @click="resetB">取消</el-button>
          </el-form-item>
        </el-form>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  data () {
    var checkUpload = (rule, value, callback) => {
      if (this.form2.bpsUploadFalse) {
        if (this.form2.uploadValue === '') {
          return callback(new Error('不能为空'))
        }
        if (this.form2.uploadValue === 0) {
          return callback(new Error('不能为0'))
        }
        if (!Number.isInteger(this.form2.uploadValue)) {
          return callback(new Error('必须为整数'))
        }
      }
      callback()
    }
    var checkDownload = (rule, value, callback) => {
      if (this.form2.bpsDownloadFalse) {
        if (this.form2.downloadValue === '') {
          return callback(new Error('不能为空'))
        }
        if (this.form2.downloadValue === 0) {
          return callback(new Error('不能为0'))
        }
        if (!Number.isInteger(this.form2.downloadValue)) {
          return callback(new Error('必须为整数'))
        }
      }
      callback()
    }
    var checkNum = (rule, value, callback) => {
      if (this.form2.segNum === '') {
        return callback(new Error('不能为空'))
      }
      if (this.form2.segNum === 0) {
        return callback(new Error('不能为0'))
      }
      if (!Number.isInteger(this.form2.segNum)) {
        return callback(new Error('必须为整数'))
      }
      callback()
    }
    var checkSize = (rule, value, callback) => {
      if (this.form2.segValue === '') {
        return callback(new Error('不能为空'))
      }
      if (this.form2.segValue === 0) {
        return callback(new Error('不能为0'))
      }
      if (!Number.isInteger(this.form2.segValue)) {
        return callback(new Error('必须为整数'))
      }
      if (this.form2.segValue < 50) {
        return callback(new Error('不能小于50'))
      }
      callback()
    }
    return {
      message: {
        Fl101: this.$lang.ui.form.l101,
        Fl126: this.$lang.ui.form.l126,
        Al231: this.$lang.ui.app.l231,
        Al232: this.$lang.ui.app.l232,
        Sl127: this.$lang.ui.system.l127,
        Sl147: this.$lang.ui.system.l147,
        Sl148: this.$lang.ui.system.l148,
        Sl234: this.$lang.ui.system.l234,
        Sl235: this.$lang.ui.system.l235,
        Nl114: this.$lang.ui.notice.l114
      },
      project: {
        storageQuota: '',
        usedStorage: '',
      },
      data: '',
      loading: false,
      loading2: false,
      active1: false,
      active2: false,
      view: {
        after: '',
        downloadAfter: ''
      },
      form: {
        ck1: true,
        ck2: false,
        ck3: false,
        saveMode: '',
        after: '',
        downloadAfter: '',
        check: [false, false, false]
      },
      view2: {
        bpsUploadFalse: false,
        upload: '',
        bpsDownloadFalse: false,
        download: '',
        mode: '',
        segNum: '',
        segSize: ''
      },
      form2: {
        bpsUploadFalse: false,
        bpsDownloadFalse: false,
        uploadValue: '',
        uploadUnit: '',
        downloadValue: '',
        downloadUnit: '',
        mode: '',
        segNum: '',
        segValue: '',
        segUnit: ''
      },
      options: [
        {
          value: 0,
          label: 'bps'
        },
        {
          value: 1,
          label: 'Kbps'
        },
        {
          value: 2,
          label: 'Mbps'
        },
        {
          value: 3,
          label: 'Gbps'
        },
        {
          value: 4,
          label: 'Tbps'
        }
      ],
      options2: [
        {
          value: 0,
          label: '分片保存'
        },
        {
          value: 1,
          label: '完整文件'
        }
      ],
      options3: [
        {
          value: 2,
          label: 'MB'
        }
      ],
      options4: [
        {
          value: 86400,
          label: '1 ' + this.$lang.ui.form.l110.l0
        },
        {
          value: 172800,
          label: '2 ' + this.$lang.ui.form.l110.l1
        },
        {
          value: 259200,
          label: '3 ' + this.$lang.ui.form.l110.l1
        },
        {
          value: 86400 * 4,
          label: '4 ' + this.$lang.ui.form.l110.l1
        },
        {
          value: 86400 * 5,
          label: '5 ' + this.$lang.ui.form.l110.l1
        },
        {
          value: 86400 * 6,
          label: '6 ' + this.$lang.ui.form.l110.l1
        },
        {
          value: 86400 * 7,
          label: '7 ' + this.$lang.ui.form.l110.l1
        },
        {
          value: 86400 * 8,
          label: '8 ' + this.$lang.ui.form.l110.l1
        },
        {
          value: 86400 * 9,
          label: '9 ' + this.$lang.ui.form.l110.l1
        },
        {
          value: 864000,
          label: '10 ' + this.$lang.ui.form.l110.l1
        },
        {
          value: 950400,
          label: '11 ' + this.$lang.ui.form.l110.l1
        },
        {
          value: 1036800,
          label: '12 ' + this.$lang.ui.form.l110.l1
        },
        {
          value: 1123200,
          label: '13 ' + this.$lang.ui.form.l110.l1
        },
        {
          value: 1209600,
          label: '14 ' + this.$lang.ui.form.l110.l1
        },
        {
          value: 86400 * 15,
          label: '15 ' + this.$lang.ui.form.l110.l1
        },
        {
          value: 86400 * 16,
          label: '16 ' + this.$lang.ui.form.l110.l1
        },
        {
          value: 86400 * 17,
          label: '17 ' + this.$lang.ui.form.l110.l1
        },
        {
          value: 86400 * 18,
          label: '18 ' + this.$lang.ui.form.l110.l1
        },
        {
          value: 86400 * 19,
          label: '19 ' + this.$lang.ui.form.l110.l1
        },
        {
          value: 86400 * 20,
          label: '20 ' + this.$lang.ui.form.l110.l1
        },
        {
          value: 86400 * 21,
          label: '21 ' + this.$lang.ui.form.l110.l1
        },
        {
          value: 86400 * 22,
          label: '22 ' + this.$lang.ui.form.l110.l1
        },
        {
          value: 86400 * 23,
          label: '23 ' + this.$lang.ui.form.l110.l1
        },
        {
          value: 86400 * 24,
          label: '24 ' + this.$lang.ui.form.l110.l1
        },
        {
          value: 86400 * 25,
          label: '25 ' + this.$lang.ui.form.l110.l1
        },
        {
          value: 86400 * 26,
          label: '26 ' + this.$lang.ui.form.l110.l1
        },
        {
          value: 86400 * 27,
          label: '27 ' + this.$lang.ui.form.l110.l1
        },
        {
          value: 86400 * 28,
          label: '28 ' + this.$lang.ui.form.l110.l1
        },
        {
          value: 86400 * 29,
          label: '29 ' + this.$lang.ui.form.l110.l1
        },
        {
          value: 86400 * 30,
          label: '30 ' + this.$lang.ui.form.l110.l1
        }
      ],
      options5: [
        {
          value: -1,
          label: '0 ' + this.$lang.ui.form.l110.l0
        },
        {
          value: 86400,
          label: '1 ' + this.$lang.ui.form.l110.l0
        },
        {
          value: 172800,
          label: '2 ' + this.$lang.ui.form.l110.l1
        },
        {
          value: 259200,
          label: '3 ' + this.$lang.ui.form.l110.l1
        },
        {
          value: 86400 * 4,
          label: '4 ' + this.$lang.ui.form.l110.l1
        },
        {
          value: 86400 * 5,
          label: '5 ' + this.$lang.ui.form.l110.l1
        },
        {
          value: 86400 * 6,
          label: '6 ' + this.$lang.ui.form.l110.l1
        },
        {
          value: 86400 * 7,
          label: '7 ' + this.$lang.ui.form.l110.l1
        }
        // {
        //   value: 864000,
        //   label: '10天'
        // },
        // {
        //   value: 950400,
        //   label: '11天'
        // },
        // {
        //   value: 1036800,
        //   label: '12天'
        // },
        // {
        //   value: 1123200,
        //   label: '13天'
        // },
        // {
        //   value: 1209600,
        //   label: '14天'
        // }
      ],
      rules: {
        upload: [
          { validator: checkUpload, trigger: 'blur' }
        ],
        download: [
          { validator: checkDownload, trigger: 'blur' }
        ],
        num: [
          { validator: checkNum, trigger: 'blur' }
        ],
        size: [
          { validator: checkSize, trigger: 'blur' }
        ]
      },
      saveModes: []
    }
  },
  props: {
    id: String,
  },
  mounted () {
    this.projectList()
    this.saveModes =
    [{
      value: 2,
      label: this.message.Al231
    },
    {
      value: 0,
      label: this.message.Al232
    }]
  },
  methods: {
    viewA () {
      var data = JSON.parse(JSON.stringify(this.data))
      if (data.project.pkg_expire === 0) {
        this.form.ck1 = false
        this.view.after = this.$lang.ui.system.l230
      } else {
        this.form.ck1 = true
        if (data.project.pkg_expire < 86400) {
          var time = ' ' + data.project.pkg_expire + 's'
        } else if (data.project.pkg_expire === 86400) {
          time = ' ' + parseInt(data.project.pkg_expire / 86400) + this.$lang.ui.form.l110.l0
        } else {
          time = ' ' + parseInt(data.project.pkg_expire / 86400) + this.$lang.ui.form.l110.l1
        }
        this.view.after = time
      }
      if (data.project.pkg_expire_after_download === 0) {
        this.form.ck2 = false
        this.view.downloadAfter = this.$lang.ui.system.l230
      } else {
        if (data.project.pkg_expire_after_download === -1) {
          this.form.ck2 = true
          this.view.downloadAfter = '0 ' + this.$lang.ui.form.l110.l0
        } else {
          this.form.ck2 = true
          if (data.project.pkg_expire_after_download < 86400) {
            time = data.project.pkg_expire_after_download + 's'
          } else if (data.project.pkg_expire_after_download === 86400) {
            time = parseInt(data.project.pkg_expire_after_download / 86400) + this.$lang.ui.form.l110.l0
          } else {
            time = parseInt(data.project.pkg_expire_after_download / 86400) + this.$lang.ui.form.l110.l1
          }
          this.view.downloadAfter = time
        }
      }
      if (data.project.allow_pkg_level_expiration === 0) {
        this.form.ck3 = false
      } else {
        this.form.ck3 = true
      }
      this.form.saveMode = data.project.save_mode === 2 ? this.saveModes[0].label : this.saveModes[1].label
    },
    viewB () {
      var data = JSON.parse(JSON.stringify(this.data))
      if (data.project.max_upload_bandwidth === 0) {
        this.form2.bpsUploadFalse = false
      } else {
        this.form2.bpsUploadFalse = true
      }
      if (data.project.max_download_bandwidth === 0) {
        this.form2.bpsDownloadFalse = false
      } else {
        this.form2.bpsDownloadFalse = true
      }
      this.view2.upload = this._global.bpsSwitch(data.project.max_upload_bandwidth)
      this.view2.download = this._global.bpsSwitch(data.project.max_download_bandwidth)
      this.form2.mode = data.project.save_mode
      if (data.project.save_mode === 0) {
        this.view2.mode = '分片模式'
      } else {
        this.view2.mode = '完整模式'
      }
      this.view2.segNum = data.project.max_segs_num
      this.view2.segSize = data.project.min_seg_size / 1024 / 1024 + ' MB'
    },
    editPkg () {
      this.active1 = true
      this.editA()
    },
    editTransfer () {
      this.active2 = true
      this.editB()
    },
    editA () {
      var data = JSON.parse(JSON.stringify(this.data))
      if (data.project.pkg_expire === 0) {
        this.form.ck1 = false
        this.form.after = 864000
      } else {
        this.form.ck1 = true
        this.form.after = data.project.pkg_expire
      }
      if (data.project.pkg_expire_after_download === 0) {
        this.form.ck2 = false
        this.form.downloadAfter = 86400
      } else {
        this.form.ck2 = true
        this.form.downloadAfter = data.project.pkg_expire_after_download
      }
      if (data.project.allow_pkg_level_expiration === 0) {
        this.form.ck3 = false
      } else {
        this.form.ck3 = true
      }
    },
    editB () {
      var data = JSON.parse(JSON.stringify(this.data))
      if (data.project.max_upload_bandwidth === 0) {
        this.form2.bpsUploadFalse = false
      } else {
        this.form2.bpsUploadFalse = true
      }
      if (data.project.max_download_bandwidth === 0) {
        this.form2.bpsDownloadFalse = false
      } else {
        this.form2.bpsDownloadFalse = true
      }
      this.form2.uploadValue = this._global.bps(data.project.max_upload_bandwidth).value
      this.form2.uploadUnit = this._global.bps(data.project.max_upload_bandwidth).unit
      this.form2.downloadValue = this._global.bps(data.project.max_download_bandwidth).value
      this.form2.downloadUnit = this._global.bps(data.project.max_download_bandwidth).unit
      this.form2.mode = data.project.save_mode
      this.form2.segNum = data.project.max_segs_num
      this.form2.segValue = this._global.bps(data.project.min_seg_size).value
      this.form2.segUnit = 2
    },
    onSubmitA () {
      if (this.form.ck1) {
        var after = this.form.after
      } else {
        after = 0
      }
      if (this.form.ck2) {
        var downloadAfter = this.form.downloadAfter
      } else {
        downloadAfter = 0
      }
      if (this.form.ck3) {
        var usersRoot = 1
      } else {
        usersRoot = 0
      }
      this.$http.put('/cydex/api/v1/projects/' + this.id, {
        'pkg_expire': after,
        'pkg_expire_after_download': downloadAfter,
        'allow_pkg_level_expiration': usersRoot,
        'save_mode': this.form.saveMode
      })
        .then(response => {
          this.projectList()
          this.$message({
            message: this.$lang.ui.prompt.l117,
            type: 'success',
            duration: 4000
          })
        })
    },
    onSubmitB () {
      this.$refs['transferForm'].validate((valid) => {
        if (valid) {
          if (!this.form2.bpsUploadFalse) {
            var upload = 0
          } else {
            upload = Math.pow(1024, this.form2.uploadUnit) * this.form2.uploadValue
          }
          if (!this.form2.bpsDownloadFalse) {
            var download = 0
          } else {
            download = Math.pow(1024, this.form2.downloadUnit) * this.form2.downloadValue
          }
          if (this.form2.mode === 0) {
            var params = {
              'max_upload_bandwidth': upload,
              'max_download_bandwidth': download,
              'save_mode': this.form2.mode,
              'max_segs_num': parseInt(this.form2.segNum),
              'min_seg_size': Math.pow(1024, this.form2.segUnit) * this.form2.segValue
            }
          } else {
            params = {
              'max_upload_bandwidth': upload,
              'max_download_bandwidth': download,
              'save_mode': this.form2.mode
            }
          }
          this.$http.put('/cydex/api/v1/projects/' + this.id, params)
            .then(response => {
              this.projectList()
              this.$message({
                message: this.$lang.ui.prompt.l117,
                type: 'success',
                duration: 4000
              })
            })
        }
      })
    },
    resetA () {
      this.viewA()
      this.active1 = false
    },
    resetB () {
      this.viewB()
      this.active2 = false
      this.$refs['transferForm'].resetFields()
    },
    projectList () {
      this.$api.getProject(this.id, response => {
        this.project.storageQuota = this._global.trafficSwitch(response.project.storage_quota)
        if (response.project.stat) {
          this.project.usedStorage = this._global.trafficSwitch(response.project.stat.total_size)
        }
        this.active1 = false
        this.active2 = false
        this.data = response
        this.viewB()
        this.viewA()
      })
    }
  }
}
</script>

<style lang="css" scoped>
.form {
  position: relative;
  width: 600px;
  font-size: 14px;
  background-color: #fff;
  -webkit-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.149019607843137);
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.149019607843137);
  margin: 15px auto;
  border-radius: 4px;
}
.pkg,
.transfer {
  position: relative;
  padding: 20px;
  padding-bottom: 40px;
  width: 100%;
  border-radius: 4px;
}
.pkg {
  margin-bottom: 40px;
}
.title {
  text-align: left;
  font-weight: 600;
}
/*.el-input {
  position: absolute;
  left: 0;
}*/
.cover {
  position: absolute;
  z-index: 2;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
}
.edit {
  position: absolute;
  cursor: pointer;
  color: #007bc5;
  top: 20px;
  right: 25px;
  display: block;
  font-size: 14px;
  font-weight: 600;
}
.cover:hover .edit {
  display: block;
}
/* .el-checkbox {
  width: 100%;
  height: 40px;
  padding-left: 30px;
  line-height: 40px;
} */
/*.ck1 .el-select {
  left: 126px;
}
.ck2 .el-select {
  left: 310px;
}*/
.el-col {
  position: absolute;;
  top: 0;
  height: 36px;
  bottom: 0;
  left: 0;
}
.cell {
  position: relative;
  height: 40px;
  line-height: 40px;
  padding-left: 31px;
  margin-bottom: 5px;
}
.overflow {
  position: relative;
  padding-left: 6px;
  font-style:italic;
  font-weight: 600;
}
</style>
